import React from 'react';
import { Redirect } from 'react-router-dom';

export function authenticatedPage (Component) {
    const componentName = Component.displayName || Component.name || 'Component'
  
    return class extends React.Component {
      static displayName = `Route(${componentName})`
  
      renderPage () {
        return (
          <Component {...this.props} />
        )
      }
  
      render () {
        let token = localStorage.getItem('access_token');
        if (token === 'null' || token === null){
          token = null;
          localStorage.removeItem('access_token');
        }

        if (token) {
          return this.renderPage()
        } else {
          return <Redirect to='/login' />
        }
      }
    }
  }


// WEBPACK FOOTER //
// ./src/components/authenticatedPage.js